import { type ReactNode, type RefObject, useEffect, useRef } from "react";
import { useResizeObserver } from "usehooks-ts";

interface WidthAwareContainerProps {
  children: ReactNode;
  setWidth?: (width: number) => void;
}

export const WidthAwareContainer = ({
  setWidth,
  children,
}: WidthAwareContainerProps) => {
  const squareRef = useRef<HTMLDivElement>(null);
  const { width = 0 } = useResizeObserver({
    ref: squareRef as RefObject<HTMLDivElement>,
  });

  useEffect(() => {
    setWidth?.(width);
    // We do not want to run effect when setWidth function changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  return <div ref={squareRef}>{children}</div>;
};
